import React from 'react';
import uniqueId from '../../../forms/utilities/unique-id';
import { useErrors } from './ErrorsContext';
import Hint from './Hint';
import Label from './Label';
import ValidationError from './ValidationError';

export default function SelectQuestion({
    name,
    label = 'Unlabelled',
    value = '',
    onChange = () => {},
    hint = null,
    options = [],
}) {
    const id = uniqueId()
    const { errors } = useErrors();

    return <div>
        <Label id={ id } small={ true }>
            { label }
        </Label>

        <div className="max-w-sm mt-1">
            <select value={ value } onChange={event => onChange(event.target.value)} className="styled-input" name={name} id={id}>
                { options.map(option => <option key={ option.value } value={ option.value }>
                    { option.label }
                </option>) }
            </select>
        </div>

        <Hint hint={ hint } />

        <ValidationError errors={ errors} name={ name } />
    </div>;
}
